import { AxiosErrorResponse } from '@core/error.models';
import { UseMutationResult } from '@tanstack/react-query';
import * as React from 'react';

export const useMutationWithOnSuccessOnError = <TReturn>(
  useMutation: () => UseMutationResult<TReturn, AxiosErrorResponse, any, unknown>,
  onSuccess: (variables: any, result: TReturn) => void,
  onError?: (variables: any, error: any) => void,
  shouldResetOnError = false,
) => {
  const mutationResult = useMutation();
  const { data, isSuccess, reset, variables, isError, error } = mutationResult;

  React.useEffect(() => {
    if (!isSuccess) return;
    onSuccess(variables, data);
    reset();
  }, [isSuccess, JSON.stringify(onSuccess)]);

  React.useEffect(() => {
    if (!isError || !error) return;

    if (onError && typeof onError === 'function') onError(variables, error);
    if (shouldResetOnError) reset();
  }, [isError, JSON.stringify(error), JSON.stringify(onError), shouldResetOnError]);

  return { ...mutationResult };
};
